import { createSlice } from '@reduxjs/toolkit';

type AuthState = {
  userId?: string;
}

export const INITIAL_STATE: AuthState = {
  userId: undefined
};

export const auth = createSlice({
  name: 'auth',
  initialState: INITIAL_STATE,
  reducers: {
    resetAuth: (state) => {
      for (const key in INITIAL_STATE) {
        (state as any)[key] = (INITIAL_STATE as any)[key];
      }
    },
    setAuthState: (state, action) => {
      const _state = action.payload;
      for (const key in INITIAL_STATE) {
        if (key in _state) {
          (state as any)[key] = (_state as any)[key];
        } else {
          (state as any)[key] = (INITIAL_STATE as any)[key];
        }
      }
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
  }
});

export const {
  resetAuth,
  setAuthState,
  setUserId
} = auth.actions;

export default auth.reducer;